import { render, staticRenderFns } from "./PrintersSettings.vue?vue&type=template&id=47f86bbe&scoped=true&"
import script from "./PrintersSettings.vue?vue&type=script&lang=js&"
export * from "./PrintersSettings.vue?vue&type=script&lang=js&"
import style0 from "./PrintersSettings.vue?vue&type=style&index=0&id=47f86bbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f86bbe",
  null
  
)

export default component.exports